export function getResultsById() {
  var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var resultsById = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


  results.forEach(function (item) {
    var uniqueId = item.uniqueId;


    console.log('item', item);

    if (item.uniqueId) {
      resultsById[item.uniqueId] = item;
    }
  });

  return resultsById;
}